import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useSocket } from './SocketContext';
import axios from 'axios';
import api from '../api';
// import { toast } from "react-toastify";

const NotificationContext = createContext();

export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const { token, profile } = useAuth();
  const { socket } = useSocket();
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);

  // Fetch notifications on mount
  useEffect(() => {
    const fetchNotifications = async () => {
      if (!token) return;
      const res = await axios.get(api.getUserNotifications, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNotifications(res.data.notifications || []);
      setNotificationCount((res.data.notifications || []).filter(n => !n.read).length);
    };
    fetchNotifications();
  }, [token]);

  // Listen for real-time notifications
  useEffect(() => {
    if (!socket || !profile?._id) return;
    // Gift notification
    const handleNewGiftNotification = (data) => {
      if (data.userId === profile._id) {
        setNotifications((prev) => [data.notification, ...prev]);
        setNotificationCount((prev) => prev + 1);
      }
    };
    socket.on('newGiftNotification', handleNewGiftNotification);
    // Course purchase notification
    const handleCoursePurchaseNotification = (data) => {
      if (data.userId === profile._id) {
        setNotifications((prev) => [data.notification, ...prev]);
        setNotificationCount((prev) => prev + 1);
      }
    };
    socket.on('newCoursePurchaseNotification', handleCoursePurchaseNotification);
    // Course update notification
    const handleCourseUpdateNotification = (data) => {
      if (data.userId === profile._id) {

        // Update notification list in context
        setNotifications((prev) => [data.notification, ...prev]);
        setNotificationCount((prev) => prev + 1);
      }
    };
    socket.on('newCourseUpdateNotification', handleCourseUpdateNotification);
    return () => {
      socket.off('newGiftNotification', handleNewGiftNotification);
      socket.off('newCoursePurchaseNotification', handleCoursePurchaseNotification);
      socket.off('newCourseUpdateNotification', handleCourseUpdateNotification);
    };
  }, [socket, profile?._id]);

  // Mark as read
  const markAsRead = async (notificationId) => {
    await axios.patch(
      `${api.getUserNotifications}/${notificationId}/read`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
    setNotifications((prev) =>
      prev.map((notif) =>
        notif._id === notificationId ? { ...notif, read: true } : notif,
      ),
    );
    setNotificationCount((prev) => Math.max(prev - 1, 0));
  };

  return (
    <NotificationContext.Provider value={{
      notifications,
      notificationCount,
      markAsRead,
      setNotifications,
      setNotificationCount,
    }}>
      {children}
    </NotificationContext.Provider>
  );
}; 